import React from 'react';
import { GeneralLoyaltyDataService } from '../../services/general-loyalty-data.service';
import { useSelector } from 'react-redux';
import { RequestStatusesEnum } from '../../../../shared/src/enums/request-statuses.enum';
import { SvgIconMask } from '../../../../shared/src/components/SvgIconMask';
import { StatusBarLoyalty } from '../../../../status_bar/src/components/StatusBarLoyalty';

export const LoyaltyBar = () => {
    const currentPlan = GeneralLoyaltyDataService.getLoyaltyPlan();
    const {
        data: loyaltyApiData,
        status: loyaltyApiRequestStatus,
    } = useSelector((state) => state.loyalty?.[currentPlan]) || {};

    if (loyaltyApiRequestStatus !== RequestStatusesEnum.SUCCEDED) {
        return null;
    }

    // Increase because levels begin from 0
    const currentLevel = loyaltyApiData.currentLevelNumber + 1;
    const externalPlanDetails = GeneralLoyaltyDataService.getPlanDetails();
    const levelsNumber = externalPlanDetails.length;
    const externalPlanIconSrc = GeneralLoyaltyDataService.getDefaultIcon();
    const CustomSvgIcon = <SvgIconMask
        iconUrl={externalPlanIconSrc}
        width={24}
        height={19}
    />;

    return <StatusBarLoyalty
        points={currentLevel}
        maxPoints={levelsNumber}
        CustomSvgIcon={CustomSvgIcon}
    />;
};
